/*eslint-disable import/default, import/namespace, import/no-named-as-default, import/no-named-as-default-member */
import React from 'react';
import api from '../utils/api';
import { createHistory } from 'history';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import loadingSentences from '../data/loading.json';
import Search from './common/Search';
import LoadingStep from './loading/LoadingStep';
import ResultsStep from './results/ResultsStep';
import ReportPage from './report/ReportPage';

const history = createHistory();
const directionPerStep = {
  0: "top",
  1: "top",
  2: "top",
  3: "top"
};

class App extends React.Component {
  constructor(props) {
    super(props);
    this.goToStep = this.goToStep.bind(this);
    this.handleUrlSubmit = this.handleUrlSubmit.bind(this);
    this.handleAnswersSubmit = this.handleAnswersSubmit.bind(this);
    this.handleLoadingFinished = this.handleLoadingFinished.bind(this);
    this.getResults = this.getResults.bind(this);
    this.getCurrentStep = this.getCurrentStep.bind(this);
    this.state = {
      step: 0,
      version: props.version,
      url: props.url,
      id: props.id,
      answers: null,
      counter: 0,
      results: null,
      bannerClass: "banner"
    };
  }

  componentWillMount() {
    if (this.props.id) {
      this.setState({step: 1});
      this.getResults(this.props.id, 5000);
    } else if (this.props.url && this.props.create) {
      setTimeout(() => {
        this.createSpeedtest(this.props.url);
        this.goToStep(1);
      }, 0);
    }
  }

  tick() {
    const {counter,step} = this.state;
    if (step >= 2) {
      return;
    }
    this.setState({counter: (counter+1) % loadingSentences.length});
  }

  goToStep(step) {
    this.setState({step: step});
  }

  startLoader() {
    if (this.timer == null) {
      this.timer = setInterval(this.tick.bind(this), 1500);
    }
  }

  endLoader() {
    clearInterval(this.timer);
    this.timer = null;
  }

  createSpeedtest(url) {
    this.startLoader();
    api.createSpeedtest(url).then((response) => {
      const path = `/${response.id}/${response.url.replace(/(^https?:\/\/|\/$)/, '')}`;
      history.push({pathname: path});
      this.setState({id: response.id, results: null});
      this.getResults(response.id);
    });
  }

  getResults(id, delay) {
    this.startLoader();
    api.pollResults(id, 30).then((response) => {
      this.setState({results: response});
      if (delay) {
        setTimeout(this.handleLoadingFinished.bind(this), delay);
      } else {
        this.handleLoadingFinished();
      }
    });
  }

  handleUrlSubmit(opts) {
    if(opts.reset) {
      this.setState({
        url: opts.url,
        answers: null,
        results: null,
        step: 1
      });
    }
    this.createSpeedtest(opts.url);
    this.setState({answers: {}});
    this.goToStep(1);
    if (this.state.results) {
      setTimeout(this.handleLoadingFinished.bind(this), 500);
    }
  }

  handleAnswersSubmit(answers) {
    this.setState({answers: answers});
    this.goToStep(2);
    if (this.state.results) {
      setTimeout(this.handleLoadingFinished.bind(this), 500);
    }
  }

  handleLoadingFinished() {
    if ((this.props.url || this.props.report) || this.state.answers) {
      this.goToStep(2);
    }
  }

  getCurrentStep() {
    switch(this.state.step) {
      case 1:
        return (
          <LoadingStep counter={this.state.counter}/>
        );
      case 2:
        return this.props.report ?
          <ReportPage results={this.state.results} /> :
          (this.state.results ? <ResultsStep
            results={this.state.results}
            answers={this.state.answers || {}}
            version={this.state.version}
            id={this.state.id}
          /> : <LoadingStep counter={this.state.counter}/>);
      default:
        return null;
    }
  }

  addClassName() {
    this.setState({bannerClass: "banner hidden"});
  }

  render() {
    let className = 'app is-step-' + this.state.step;
    let element = (
      <ReactCSSTransitionGroup
        transitionName={`slider-${directionPerStep[this.state.step]}`}
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
        className="app__steps__transitions">
        <div className="app__steps__item" key={this.state.step}>{this.getCurrentStep()}</div>
      </ReactCSSTransitionGroup>
    );

    return (
      <div className={className}>
        {!this.props.report && <Search url={this.state.url} currentStep={this.state.step} onComplete={this.handleUrlSubmit} />}
        <div className="app__steps">
          {element}
        </div>
      </div>
    );
  }
}

App.propTypes = {
  create: React.PropTypes.bool,
  url: React.PropTypes.string,
  id: React.PropTypes.string,
  version: React.PropTypes.string
};

App.defaultProps = {
  id: '',
  url: '',
  version: 'a'
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js